import { Component, OnInit } from '@angular/core';
import { SearchIndicationsModel } from '@app/models/search-indications';
import { UTrackUIEvent } from '@app/models/utrack-ui-event';
import { SharedService } from '@app/services/shared.service';
import { VennHealthDataService } from '@app/services/vennhealth-data.service';
import { vennHealthConstants } from '@app/shared/vennHealthConstants';
import { debounceTime, distinctUntilChanged, filter, map, Observable, OperatorFunction } from 'rxjs';

@Component({
  selector: 'app-search-indications',
  templateUrl: './search-indications.component.html',
  styleUrls: ['./search-indications.component.css']
})
export class SearchIndicationsComponent implements OnInit {
   
	indicationSearchModel: SearchIndicationsModel[] = vennHealthConstants.searchIndications;

	constructor(private readonly sharedService: SharedService, private readonly vennhealthDataService: VennHealthDataService) { }

	ngOnInit() {
	}

	public model: SearchIndicationsModel;

	formatter = (indication: SearchIndicationsModel) => indication.name;

	search: OperatorFunction<string, readonly SearchIndicationsModel[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			filter((term) => term.length >= 2),
			map((term) => this.indicationSearchModel.filter((indication) => {
				const keywords: string = indication.name.concat(...indication.keywords);
				const match = new RegExp(term, 'mi').test(keywords);
				return match;
			}).slice(0, 10)),
		);

	indicationSelected(selectedIndication: any): void {
		if (selectedIndication.hasOwnProperty('item')) {
			const e: UTrackUIEvent = {
				details: 'Search Indication Selection',
				additionalDetails: selectedIndication.item.name
			};
			this.vennhealthDataService.utrackEvent(e).subscribe();

			this.sharedService.setSelectedSearchIndication(selectedIndication.item);
		}
	}

	clearSearch(): void {
		this.model = undefined;
		this.sharedService.setSelectedSearchIndication(null);
	}

	resetSearch(): void {
		this.clearSearch();
		this.sharedService.setcloseAllPanels();
	}
}
